import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Catalog from "../pages/catalog/page";
import K4M from "../pages/k4m/page";
import Lubricants from "../pages/lubricants/page";
import IndustrialOils from "../pages/industrial-oils/page";
import FoundryMachining from "../pages/foundry-machining/page";
import EngineBlockCatalog from "../pages/engine-block-catalog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/catalog",
    element: <Catalog />,
  },
  {
    path: "/lubricants",
    element: <Lubricants />,
  },
  {
    path: "/industrial-oils",
    element: <IndustrialOils />,
  },
  {
    path: "/foundry",
    element: <K4M />,
  },
  {
    path: "/foundry-machining",
    element: <FoundryMachining />,
  },
  {
    path: "/engine-block-catalog",
    element: <EngineBlockCatalog />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
